import {pageInfo, detail} from '../api';
import {plant} from '../../../../api';

const kejianTmsVehicle = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null,
    detailObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    DETAIL(state, data) {
      state.detailObj = data;
    }
  },
  actions: {
    //分页查询
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //基地下拉
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    //详情查询
    async detail({commit}, obj) {
      let resp = await detail(obj);
      commit('DETAIL', resp);
    }
  }
};
export default kejianTmsVehicle;



// WEBPACK FOOTER //
// ./src/page/int/kejianTmsVehicle/store/kejianTmsVehicle.store.js